export default function (text, subject = '') {
  return this.sendEventWithCallback('share', { text, subject })
    .then(data => {
      // shortcut: success
      if (data.shared === true) {
        return
      }

      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
